import { render, staticRenderFns } from "./ColumnConfigDialog.vue?vue&type=template&id=2e55c604&scoped=true&"
import script from "./ColumnConfigDialog.vue?vue&type=script&lang=js&"
export * from "./ColumnConfigDialog.vue?vue&type=script&lang=js&"
import style0 from "./ColumnConfigDialog.vue?vue&type=style&index=0&id=2e55c604&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e55c604",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e55c604')) {
      api.createRecord('2e55c604', component.options)
    } else {
      api.reload('2e55c604', component.options)
    }
    module.hot.accept("./ColumnConfigDialog.vue?vue&type=template&id=2e55c604&scoped=true&", function () {
      api.rerender('2e55c604', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Analysis/components/ColumnConfigDialog.vue"
export default component.exports